/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Final_HInputs */

const en_wc_final_h = /** @type {(inputs: Wc_Final_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how to start.`)
};

/**
* | output |
* | --- |
* | "Choose how to start." |
*
* @param {Wc_Final_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_final_h = /** @type {((inputs?: Wc_Final_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Final_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_final_h(inputs)
});
export { wc_final_h as "wc.final.h" }